import { useContext, useEffect, useRef } from "react";
import olMap from "ol/Map";
import { Coordinate } from "ol/coordinate";
import MapContext from "../map/MapContext";

export interface ViewMoveEndProps {
  onMoveEnd: (center: Coordinate, zoom: number) => void;
}

const ViewMoveEnd = ({ onMoveEnd }: ViewMoveEndProps) => {
  const map = useContext(MapContext) as olMap;

  const onMoveEndRef = useRef(onMoveEnd);
  useEffect(() => {
    onMoveEndRef.current = onMoveEnd;
  }, [onMoveEnd]);

  useEffect(() => {
    if (!map) return;

    const handler = () => {
      const view = map.getView();
      const center = view.getCenter();
      const zoom = view.getZoom();
      if (center && zoom !== undefined) {
        onMoveEndRef.current(center, zoom);
      }
    };

    map.on("moveend", handler);
    return () => {
      map.un("moveend", handler);
    };
  }, [map]);

  return null;
};

export default ViewMoveEnd;
